import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { name: '情感咨询', path: '/category/emotional-consultation' },
      { name: '两性健康', path: '/category/sexual-health' },
      { name: '伴侣沟通', path: '/category/partner-communication' },
      { name: '亲密关系', path: '/category/intimacy-relationship' },
      { name: '自我成长', path: '/category/self-growth' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '专家团队', path: '/about#team' },
      { name: '用户口碑', path: '/about#testimonials' },
      { name: '联系我们', path: '/about#contact' },
    ],
  },
  {
    title: '帮助与支持',
    links: [
      { name: '常见问题', path: '/#faq' },
      { name: '隐私政策', path: '/about' },
      { name: '使用条款', path: '/about' },
      { name: '投稿合作', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>爱爱网</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5">
              专注成人情感与亲密关系的专业平台。
              <br />
              用科学与温暖，陪伴每一段亲密关系。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-200/70 flex items-center justify-center text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微信公众号">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-200/70 flex items-center justify-center text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-200/70 flex items-center justify-center text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">{group.title}</h4>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 爱爱网 aiaiwang.com 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <p className="text-xs text-foreground-400">
            本站内容仅供成年人阅读，请理性参考
          </p>
        </div>
      </div>
    </footer>
  );
}